export const getAuthHeader = () => {
  try {
    return getUserFromLS().identity.token || '';
  } catch (err) {
    return '';
  }
};

export const getUserFromLS = () => {
  const emptyUser = {
    meta: {
      lang: "de"
    },
    identity: {
      role: "ivs",
      token: null,
      firstname: null,
      lastname: null,
      prefix: null,
      fullname: null,
      email: null,
      id: null,
      isRBPartner: false
    }
  }

  try {
    const serializedUser = localStorage.getItem('user');
    if (!!!serializedUser) {
      return emptyUser;
    }

    return JSON.parse(serializedUser);
  } catch (err) {
    return emptyUser;
  }
};

export const deleteUserFromLS = () => {
  localStorage.removeItem('user');
};

export const setUserToLS = user => {
  try {
    localStorage.setItem('user', JSON.stringify(user));
  } catch (err) {
    console.error(err)
  }
};

export const deleteCookie = (name, opts = {}) => {
  const options = { expires: -1 };
  setCookie(name, '', Object.assign(options, opts));
};

export const setCookie = (cookieName, value, daysOrOptions = 1) => {
  const options = Number.isInteger(daysOrOptions)
    ? computeCookieOptions({ expires: daysOrOptions })
    : computeCookieOptions(daysOrOptions);
  document.cookie = cookieName + '=' + encodeURIComponent(value) + options + ";SameSite=Lax";
};

export const getCookie = cookieName => {
  cookieName = cookieName.replace(/[.*+?^$|[\](){}\\-]/g, '\\$&');
  const regexExpression = '(?:^|; )' + cookieName + '(?:=([^;]*?))?(?:;|$)';
  const result = new RegExp(regexExpression).exec(document.cookie);
  return result !== null ? decodeURIComponent(result[1]) : null;
};

export const computeCookieOptions = options => {
  const result = Object.keys(options).reduce((acc, key) => {
    if (key === 'secure') {
      return acc + (options[key] ? `;secure` : '');
    }

    if (key === 'expires') {
      const expires = options[key];
      switch (typeof expires) {
        case 'number':
          options[key] = stringExpiresToDate(`${expires}D`).toUTCString();
          break;
        case 'string':
          options[key] = stringExpiresToDate(expires).toUTCString();
          break;
        default:
          options[key] = expires.toUTCString();
          break;
      }
    }

    return `${acc};${key}=${options[key]}`;
  }, '');

  if (options.hasOwnProperty('path') === false) {
    return result + ';path=/';
  }

  return result;
};

export const stringExpiresToDate = str => {
  let expires = new Date();
  const lastCharacter = str.charAt(str.length - 1);
  const value = parseInt(str, 10);

  switch (lastCharacter) {
    case 'Y':
      expires.setFullYear(expires.getFullYear() + value);
      break;
    case 'M':
      expires.setMonth(expires.getMonth() + value);
      break;
    case 'D':
      expires.setDate(expires.getDate() + value);
      break;
    case 'h':
      expires.setHours(expires.getHours() + value);
      break;
    case 'm':
      expires.setMinutes(expires.getMinutes() + value);
      break;
    case 's':
      expires.setSeconds(expires.getSeconds() + value);
      break;
    default:
      expires = new Date(str);
  }

  return expires;
};

export const getQuoteAuth = () => {
  const cookie = getCookie('om_frontend');
  return btoa('wp:' + cookie);
};

export const deleteFrontendCookies = () => {
  deleteCookie('om_frontend', { domain: `.${window.location.hostname}` });
  deleteCookie('om_frontend', { domain: `${window.location.hostname}` });
  deleteCookie('PHPSESSID', { domain: `.${window.location.hostname}` });
  deleteCookie('PHPSESSID', { domain: `${window.location.hostname}` });
};
